document.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll(".distributor_search-layout .distributor-search-form").forEach((form) => {
		const locate = form.querySelector(".distributor-search-locate");
		const postcode = form.querySelector('input[name="postcode"]');
		const lat = form.querySelector('input[name="lat"]');
		const lng = form.querySelector('input[name="lng"]');

		form.addEventListener("submit", (event) => {
			if (!postcode.value.trim() && lat.disabled) {
				event.preventDefault();
				postcode.focus();
			}
		});

		if (!locate) return;

		if (!("geolocation" in navigator)) {
			locate.hidden = true;
			return;
		}

		locate.addEventListener("click", () => {
			form.classList.add("is-locating");

			navigator.geolocation.getCurrentPosition(
				(position) => {
					lat.value = position.coords.latitude.toFixed(5);
					lng.value = position.coords.longitude.toFixed(5);
					lat.disabled = false;
					lng.disabled = false;
					postcode.disabled = true;
					form.submit();
				},
				() => {
					form.classList.remove("is-locating");
					postcode.focus();
				},
				{ timeout: 10000, maximumAge: 300000 },
			);
		});
	});
});
